<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  modelValue: string[]
  label: string
  placeholder?: string
  inputClasses?: string
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: '--',
  inputClasses: 'bg-white border',
})

const emits = defineEmits<{
  (event: 'update:modelValue', modelValue: string[]): void
}>()

const values = ref<string[]>([...props.modelValue])

watch(
  values,
  (newValue) => {
    if (newValue.length === 0) {
      values.value.push('')
      return
    }
    emits(
      'update:modelValue',
      newValue.filter((value) => !!value.trim()),
    )
  },
  { deep: true, immediate: true },
)

function addText() {
  values.value.push('')
}

function removeText(index: number) {
  values.value.splice(index, 1)
}
</script>

<template>
  <div>
    <label class="text-primary-800 me-1 pb-1 small"> {{ label }} </label>
    <div v-for="(item, index) in values" :key="index" class="d-flex gap-2 mb-2 position-relative">
      <input
        :id="`certificate-item-${index}`"
        v-model="values[index]"
        type="text"
        class="form-control"
        :class="inputClasses"
        :placeholder="placeholder"
      />

      <button
        v-if="values.length > 1"
        class="btn-close m-2 position-absolute end-0"
        type="button"
        @click="removeText(index)"
      ></button>
    </div>

    <div class="w-100 d-flex justify-content-end">
      <button class="btn btn-primary fs-4 d-flex p-0" type="button" @click="addText">
        <i-bi-plus />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables';

select:disabled {
  pointer-events: none;
  color: rgba($info, 0.3) !important;
}
</style>
